import React, { useContext } from 'react';
import './commerce.css';
import { connect } from 'react-redux';
import button_collapsed from '../../assets/images/button-collapsed.svg';
import button_expanded from '../../assets/images/button-expanded.svg';

import {
  Row,
  Col,
  Accordion,
  Card,
  Image,
  useAccordionToggle,
  AccordionContext
} from 'react-bootstrap';


const ItemCommerce = ({ data, onCommerceSelect }) => {
  function ContextAwareToggle({ children, eventKey, callback }) {
    const decoratedOnClick = useAccordionToggle(eventKey,() => callback && callback(eventKey),);
    return (
        <div onClick={decoratedOnClick} >
          {children}
        </div>
    );
  }
  
  const cintext = useContext(AccordionContext);
  
  function handleOnClick(e, item){
    e.stopPropagation() 
    onCommerceSelect(item)
  }
  return (
    <React.Fragment>
      <ContextAwareToggle eventKey={data.index === 0 ? '0' : data.index}>
        <Card className="accordion-card" style={{cursor:"pointer"}} >
          <Card.Header className="card-header-maps">
            <Row>
              <Col className="accordion-title">{data.item && data.item.brandToken}</Col>
              <Col>
                <Image
                  className="float-right button-toggle"
                  height="20"
                  width="20"
                  src={data.index == cintext ? button_collapsed : button_expanded}
                />
              </Col>
            </Row>
          </Card.Header>
          <Accordion.Collapse eventKey={data.index === 0 ? '0' : data.index}>
            <Card.Body onClick={(e) => {handleOnClick(e, data.item)}} className="body-commerce">
              {data.item.address && data.item.address.toLowerCase()}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </ContextAwareToggle>
    </React.Fragment>
  );
}

const mapStateProps = (state) => {
  return {}
}

export default connect(
  mapStateProps,
  {}
)(ItemCommerce)
